var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXLogoAboutUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#212121"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1485_2206)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1485_2206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 7,
    height: 7
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23071 9.23047H15.6923V15.692H9.23071V9.23047Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1485_2206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3192 9.5332H15.3101L13.1455 12.0135L15.6923 15.3892H13.6984L12.1356 13.3423L10.3495 15.3892H9.35764L11.6727 12.7354L9.23071 9.53366H11.2753L12.6858 11.4043L14.3192 9.5332ZM13.9707 14.7947H14.5199L10.9753 10.0967H10.3864L13.9707 14.7947Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1485_2206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.46154,
    height: 6.46154,
    fill: "white",
    transform: "translate(9.23071 9.23047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXLogoAboutUs);
export default __webpack_public_path__ + "static/media/x-logo-aboutUs.bed1f2ef95501b46fb9b82847575be05.svg";
export { ForwardRef as ReactComponent };